/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ComponentStyleConfig,
  SystemStyleFunction,
  SystemStyleObject,
} from '@chakra-ui/react';

const baseStyle = {
  borderRadius: 'none',
  textTransform: 'uppercase',
  fontSize: { base: 'medium', md: 'large' },
  px: 8,
  py: 3,
  _disabled: {
    opacity: 1,
  },
};

const containedBaseStyle = {
  ...baseStyle,
  _hover: {
    cursor: 'pointer',
    boxShadow: 'brand.hover',
    _disabled: {
      boxShadow: 'none',
    },
  },
};

const linkVariant: SystemStyleObject = { ...baseStyle, textTransform: 'none' };

const mbePrimaryVariant: SystemStyleFunction = (props) => {
  const { theme } = props;
  return {
    ...containedBaseStyle,
    bg: theme.colors.brand.red.light,
    border: theme.borders['2px'],
    borderColor: theme.colors.brand.red.light,
    color: 'white',
    _active: {
      bg: theme.colors.brand.red.dark,
      borderColor: theme.colors.brand.red.dark,
    },
    _hover: {
      _disabled: {
        bg: '#ccc',
        borderColor: '#ccc',
      },
    },
    _disabled: {
      bg: '#ccc',
      borderColor: '#ccc',
    },
  };
};

const mbeSecondaryVariant: SystemStyleFunction = (props) => {
  const { theme } = props;
  return {
    ...containedBaseStyle,
    bg: 'white',
    color: theme.colors.brand.red.light,
    border: theme.borders['2px'],
    borderColor: theme.colors.brand.red.light,
    _active: {
      color: theme.colors.brand.red.dark,
      borderColor: theme.colors.brand.red.dark,
    },
    _hover: {
      _disabled: {
        color: '#ccc',
        borderColor: '#ccc',
      },
    },
    _disabled: {
      color: '#ccc',
      borderColor: '#ccc',
    },
  };
};

const mbeSecondaryDarkVariant: SystemStyleFunction = (props) => {
  const { theme } = props;
  return {
    ...containedBaseStyle,
    color: 'white',
    border: theme.borders['2px'],
    borderColor: 'white',
    _hover: {
      bg: 'rgba(255, 255, 255, 0.2)',
      _disabled: {
        color: '#ccc',
        borderColor: '#ccc',
      },
    },
    _disabled: {
      color: '#ccc',
      borderColor: '#ccc',
    },
  };
};

const dotVariant: SystemStyleObject = {
  bg: 'brand.black',
  borderRadius: '50%',
  w: '8px',
  h: '8px',
  p: 0,
  mr: 4,
  _hover: {
    boxShadow: 'none',
    _disabled: {
      color: '#ccc',
      borderColor: '#ccc',
    },
  },
  _disabled: {
    color: '#ccc',
    borderColor: '#ccc',
  },
};

const ButtonStyle: ComponentStyleConfig = {
  // style object for base or default style
  variants: {
    mbePrimary: mbePrimaryVariant,
    mbeSecondary: mbeSecondaryVariant,
    mbeSecondaryDark: mbeSecondaryDarkVariant,
    dot: dotVariant,
    link: linkVariant,
  },
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: '',
    variant: '',
    colorScheme: '',
  },
};

export default ButtonStyle;
